import { Link } from 'react-router-dom';
import { Buildings, ArrowLeft } from '@phosphor-icons/react';
import LegalFooter from '../../components/LegalFooter';

/** Gemeinsames Layout-Wrapper für die statischen Rechts-Seiten.
 *  Öffentlich erreichbar – auch ohne Login.
 */
export function LegalPageLayout({ title, lastUpdated, children, testId }) {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col" data-testid={testId}>
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-slate-900 hover:text-violet-700 transition-colors">
            <Buildings weight="duotone" className="w-6 h-6" />
            <span className="font-heading text-base font-bold">Immo Verwalter</span>
          </Link>
          <Link
            to="/login"
            className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900"
            data-testid="legal-back-link"
          >
            <ArrowLeft weight="bold" className="w-4 h-4" />
            Zurück
          </Link>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
          <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tight text-slate-900">{title}</h1>
          {lastUpdated && (
            <p className="text-xs text-slate-400 mt-1">Stand: {lastUpdated}</p>
          )}
          <div className="prose prose-slate max-w-none mt-6 text-sm leading-relaxed text-slate-700">
            {children}
          </div>
        </div>
      </main>

      <LegalFooter />
    </div>
  );
}
